function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.9972 4.3001H12.6094C11.0329 4.30287 9.75573 5.54811 9.75289 7.08525C9.75076 8.62586 11.0293 9.87664 12.6094 9.87872H16V10.1235C16 12.8109 14.3708 14.4 11.6139 14.4H4.38684C1.62916 14.4 0 12.8109 0 10.1235V4.27029C0 1.5829 1.62916 0 4.38684 0H11.611C14.368 0 15.9972 1.5829 15.9972 4.27029V4.3001ZM3.79164 4.2955H8.30364H8.30648H8.31217C8.64995 4.29411 8.92302 4.02579 8.9216 3.69576C8.92017 3.36642 8.64426 3.10018 8.30648 3.10157H3.79164C3.456 3.10295 3.18364 3.3685 3.18222 3.69645C3.1808 4.02579 3.45386 4.29411 3.79164 4.2955Z",
  fill: "white"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  d: "M11.2299 7.43687C11.3972 8.19781 12.0644 8.73319 12.8261 8.71927H15.426C15.7429 8.71927 16 8.4568 16 8.13237V6.10712C15.9993 5.78339 15.7429 5.52023 15.426 5.51953H12.7649C11.8984 5.52232 11.1986 6.24149 11.2 7.12775C11.2 7.23149 11.2102 7.33522 11.2299 7.43687Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 12.8,
  cy: 7.12031,
  r: 0.8,
  fill: "white"
});

function SvgWalletIconWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2, _ref3);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletIconWhite);
export default __webpack_public_path__ + "static/media/walletIconWhite.2d694f66.svg";
export { ForwardRef as ReactComponent };